import { useRef, useEffect } from 'react'

const useClickOutside = (onClickOutside) => {
  const ref = useRef()

  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      onClickOutside(e)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClick)
    return () => {
      document.removeEventListener('click', handleClick)
    }
    // FIXME: dont ignore
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current])

  return { ref }
}

export default useClickOutside
